import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import ConfigurationActions from '../../redux/configurationRedux';
import ShownStepsActions from '../../redux/shownStepsRedux';
import PartsActions from '../../redux/partsRedux';
import { isNil } from '../../services/helper';
import style from '../scenes.scss';

// Components
import PackageBox from '../../components/selectionBoxes/packageBox/packageBoxComponent';
import PackageDetails from '../../components/selectionBoxes/packageBox/packageDetailsComponent';
import SceneNotice from '../../components/notice/sceneNoticeComponent';
import checkDependencies from '../../services/dependencies';
import getFlattenedConfiguration from '../../redux/selectors/getFlattenedConfiguration';
import resolvePrice from '../../services/helper/resolvePrice';
import checkMarkedDependency from '../../services/helper/checkMarkedDependency';

class PackageScene extends Component {
    constructor(props) {
        super(props);

        this.state = {
            detailsId: null,
            showPackageDetails: false,
        };
    }

    componentWillMount() {
        this.listItems();
    }

    listItems = () => {
        const { listPartsRequest, parts, configuration } = this.props;
        if (isNil(parts.packages) || configuration.refreshing) {
            listPartsRequest('all', configuration.model.id);
            this.props.setRefreshing(false);
        }
    }

    showPackageDetails = (id) => {
        this.setState({ detailsId: id, showPackageDetails: true });
    }

    onClose = () => {
        this.setState({ showPackageDetails: false });
    }

    onSelectItem = (pack) => {
        const { configuration, updateConfiguration, parts } = this.props;
        if (!isNil(pack) && !pack.disabled) {
            let selectedItems = [...configuration.configurations.packs]; // eslint-disable-line prefer-const, max-len

            const index = selectedItems.findIndex(
                (selectedItem) => selectedItem.uid === pack.uid
            );

            if (index !== -1) {
                selectedItems.splice(index, 1);
            } else {
                const inclusiveOrs = pack.inclusive_or;
                selectedItems.forEach((selectedItem, selectedItemIndex) => {
                    if (inclusiveOrs.indexOf(selectedItem.uid) !== -1) {
                        selectedItems.splice(selectedItemIndex, 1);
                    }
                });
                selectedItems.push(pack);
            }
            updateConfiguration('packs', selectedItems, parts, pack);
        }
    };

    setPreselectedItems = () => {
        const {
            navigation,
            shownSteps,
            addShownStep,
            parts,
            configuration,
            updateConfiguration,
        } = this.props;
        let selectedItems = [...configuration.configurations.packs]; // eslint-disable-line prefer-const, max-len

        // Early return, if the step has already been rendered before
        if (shownSteps.indexOf(navigation.active) > -1) {
            return;
        }

        parts.packages.data.forEach((packageItem) => {
            if (packageItem.preselected || packageItem.mandatory) {
                const index = configuration.configurations.packs.indexOf(packageItem);
                if (index === -1) {
                    selectedItems.push(packageItem);
                    updateConfiguration('packs', selectedItems, parts);
                }
            }
        });
        addShownStep(navigation.active);
    }

    resolvePrice = (part, serialParentUid) => resolvePrice(
        part, serialParentUid, this.props.configuration.configurations
    );

  disableParts = (parts) => {
      const { configuration, updateConfiguration, flatConfigurationParts } = this.props;
      const disabledParts = checkDependencies(parts, flatConfigurationParts);

      let selectedItems = [...configuration.configurations.packs]; // eslint-disable-line prefer-const, max-len
      selectedItems.forEach((item, index) => {
          if (disabledParts.indexOf(item.uid) !== -1) {
             selectedItems.splice(index, 1);
             updateConfiguration('packs', selectedItems, parts);
          }
      });

      return parts.map((part) => {
          if (disabledParts.indexOf(part.uid) !== -1) {
              return { ...part, disabled: true };
          }
          return part;
      });
  };

    renderPackageItems = () => {

        const { parts, configuration } = this.props;

        if (isNil(parts.packages)) {
            return null;
        }

        this.setPreselectedItems();

      const itemList = this.disableParts([...parts.packages.data]);
      let view = (
            <div className={style.form_container}>
                {itemList.map((packageItem) => (
                    <PackageBox
                        key={packageItem.uid}
                        package={packageItem}
                        showPackageDetails={() => this.showPackageDetails(packageItem.uid)}
                        selectedItems={configuration.configurations.packs}
                        onSelectItem={(item) => this.onSelectItem(item)}
                        onClose={this.onClose}
                        parts={parts}
                        resolvePrice={this.resolvePrice}
                        configuration={configuration.configurations}
                    />
                ))}
            </div>
        );

        if (this.state.showPackageDetails) {

            let pack = null; // eslint-disable-line prefer-const

            for (let i = 0; i < parts.packages.data.length; i += 1) {
                if (parts.packages.data[i].uid === this.state.detailsId) {
                    pack = parts.packages.data[i];
                }
            }

            view = (
                <div className={style.container}>
                    <PackageDetails
                        package={pack}
                        onClose={this.onClose}
                    />
                </div>
            );
        }

        return view;
    }

    render() {
        const { parts, configuration } = this.props;

        if (this.props.fetching === null || this.props.fetching === true) {
            return (
                <h2>{t`LADE`}</h2>
            );
        }
        let hasMarkedDependency = false;
        hasMarkedDependency = checkMarkedDependency(
            parts.packages.data,
            configuration.markedDependencies
        );
        return (
            <div className={style.scene}>
                <div className={style.title}>
                    <h2>{t`Paket wählen`}</h2>
                </div>
                <form>
                    {
                        hasMarkedDependency ?
                            <SceneNotice content={t`Sie haben nun die Möglichkeit Ihre Konfiguration zu ändern. Eine Änderung kann ggf. Auswirkungen auf die bestehende Konfiguration haben. Bitte prüfen Sie die folgenden Einstellungen!`} />
                            : null
                    }
                    {this.renderPackageItems()}
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    caravans: state.caravans.caravans,
    parts: state.parts.parts,
    fetching: state.parts.fetching,
    configuration: state.configuration,
    flatConfigurationParts: getFlattenedConfiguration(state.configuration.configurations),
    navigation: state.navigation,
    shownSteps: state.shownSteps,
});

const mapDispatchToProps = dispatch => ({
    updateConfiguration: (category, value, parts, changedItem) =>
        dispatch(ConfigurationActions.updateConfiguration(category, value, parts, changedItem)),
    listPartsRequest: (category, identifier) =>
        dispatch(PartsActions.listPartsRequest(category, identifier)),
    setRefreshing: (refresh) =>
        dispatch(ConfigurationActions.setRefreshing(refresh)),
    addShownStep: (stepId) =>
        dispatch(ShownStepsActions.addShownStep(stepId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PackageScene);

